import Vue from 'vue';
const resource = '/workorders';

export default {
  automaticReservation(categoryTypeIdPublic, idPublic) {
    if (categoryTypeIdPublic == null) {
      return Vue.prototype.$axiosMainClient.put(
        `${resource}/${idPublic}/automaticreservation`
      );
    } else {
      return Vue.prototype.$axiosMainClient.put(
        `${resource}/${idPublic}/automaticreservation?categorytype=${categoryTypeIdPublic}`
      );
    }
  },
  consume(idPublic) {
    return Vue.prototype.$axiosMainClient.put(
      `${resource}/${idPublic}/consume`
    );
  },
};
